import { SortByOption } from "@ms/uno-constants/lib/local/SortingConstants";
/**
 * Maps stored sort criteria to a `SortByOption` for the My Tasks view.
 * Unknown / unset values default to `None` so first-load
 * shows tasks in order-hint + created-date desc order (per spec).
 */ export function toSortByOption(criteria) {
    const field = criteria?.primary?.field;
    switch(field){
        case SortByOption.DueDate:
        case SortByOption.CreatedDate:
        case SortByOption.Priority:
        case SortByOption.Name:
        case SortByOption.None:
            return field;
        default:
            return SortByOption.None;
    }
}
/**
 * Encodes a `SortByOption` as `ISortCriteria` for persistence. Direction is
 * fixed per option (no toggle), so `isAscending` reflects spec intent rather
 * than user choice.
 */ export function toSortCriteria(option) {
    return {
        primary: {
            field: option,
            // CreatedDate is the only descending option per spec (newest first).
            // None (manual order) direction is immaterial — the resolver uses order hints.
            isAscending: option !== SortByOption.CreatedDate
        }
    };
}
